import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 25 24",
    color: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M18.892 9.2q-1.8-3-5.4-6.9c-.1-.1-.2-.1-.3-.2-.1 0-.2-.1-.3-.1s-.2 0-.3.1c-.1 0-.2.1-.3.2q-3.6 3.9-5.4 6.9c-1.2 2-1.8 3.7-1.8 5.2 0 2.1.9 4 2.3 5.4s3.4 2.2 5.5 2.2 4-.8 5.5-2.2 2.3-3.4 2.3-5.4c0-1.5-.6-3.2-1.8-5.2m.2 5.2c0 1.6-.7 3.2-1.8 4.4-1.2 1.2-2.7 1.8-4.4 1.8-1.6 0-3.2-.7-4.4-1.8-1.2-1.2-1.8-2.7-1.8-4.4 0-1.1.5-2.5 1.6-4.3 1-1.7 2.6-3.7 4.6-6 2.1 2.3 3.6 4.3 4.6 6 1.1 1.7 1.6 3.2 1.6 4.3" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.392 13c.4 0 .7.3.7.8 0 .8.2 1.9.9 2.8.6.9 1.7 1.6 3.6 1.6.4 0 .8.3.8.7s-.3.8-.7.8c-2.3 0-3.9-1-4.8-2.3-.9-1.2-1.2-2.7-1.2-3.7-.1-.4.2-.7.7-.7" fill="currentColor"/>' }
  })
);